import { useTranslationKeys } from '@bringg-frontend/utils';

export const translationKeys = {
	uploadTitle: 'EXCLUSION_WINDOWS_CSV.UPLOAD_TITLE',
	uploadDescription: 'EXCLUSION_WINDOWS_CSV.UPLOAD_DESCRIPTION',
	mappingDescription: 'EXCLUSION_WINDOWS_CSV.MAPPING_DESCRIPTION',
	uploadFailed: 'TASKS_CSV_UPLOADER.ERROR_MESSAGE',
	uploadSuccess: 'TASKS_CSV_UPLOADER.SUCCESS_MESSAGE',
	templateName: 'EXCLUSION_WINDOWS_CSV.TEMPLATE_NAME',
	status: 'EXCLUSION_WINDOWS_CSV.UPLOAD_TITLE',
	originalField: 'EXCLUSION_WINDOWS_CSV.ORIGINAL_FIELD',
	search: 'GLOBAL.SEARCH',
	approveAndGenerate: 'EXCLUSION_WINDOWS_CSV.APPROVE_AND_GENERATE',
	matched: 'EXCLUSION_WINDOWS_CSV.MATCHED',
	mandatory: 'EXCLUSION_WINDOWS_CSV.MANDATORY_FIELDS',
	mandatoryDescription: 'EXCLUSION_WINDOWS_CSV.MANDATORY_FIELDS_DESCRIPTION',
	progressTitle: 'EXCLUSION_WINDOWS_CSV.UPLOAD_TITLE',
	downloadErrorsFile: 'EXCLUSION_WINDOWS_CSV.DOWNLOAD_ERRORS_FILE',
	parsingFile: 'EXCLUSION_WINDOWS_CSV.PARSING_FILE',
	failedToFetchStatus: 'EXCLUSION_WINDOWS_CSV.FAILED_TO_FETCH_STATUS',
	keepMapping: 'EXCLUSION_WINDOWS_CSV.KEEP_MAPPING',
	learnMore: 'EXCLUSION_WINDOWS_CSV.LEARN_MORE',
	finish: 'GLOBAL.FINISH',
	close: 'GLOBAL.CLOSE',
	downloadAndClose: 'EXCLUSION_WINDOWS_CSV.DOWNLOAD_AND_CLOSE',
	confirmNonAssignedTasks: 'EXCLUSION_WINDOWS_CSV.CONFIRM_NON_ASSIGNED_TASKS',
	confirmNonAssignedTasksDescription: 'EXCLUSION_WINDOWS_CSV.CONFIRM_NON_ASSIGNED_TASKS_DESCRIPTION',
	failedToParseFile: 'EXCLUSION_WINDOWS_CSV.FAILED_TO_PARSE_FILE'
};

export function useCSVImportTranslation() {
	return useTranslationKeys<typeof translationKeys>(translationKeys);
}
